import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SubscriptionPopupUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(requestData) {
        return await this.repo.getRateBasedSubscriptionPopup(requestData);
    }
}
export default SubscriptionPopupUseCase;
